import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import '../css/app.css';
//Route Imports
import AppRoute from './AppRoute';
import RootRedirect from './RootRedirect';
import RequireAuth from './RequireAuth';

//Layout
import StaticLayout from '../layouts/StaticLayout';

//Components
import Home from '../pages/Home';
import AccountGo from '../pages/Account/go';
import Unauthorized from '../components/Unauthorized';
import PageNotFound from '../pages/PageNotFound';
import Loading from '../components/UI/loading';
import StaticAuth from '../pages/StaticAuth';
import Applications from '../pages/Applications';
import { Logout } from '../pages/Logout';
import MarylandSherpa from 'features/ApplicationForm/FormConfig/Maryland/Sherpa';

//Lazyloading
const PartnerSignUp = React.lazy(
  () => import('../pages/Auth/PartnerAuth/SignUp')
);
const UserOnboard = React.lazy(() => import('../pages/UserOnboard'));
const ResetPassword = React.lazy(() => import('../pages/Auth/ResetPassword'));

export default function Allroute() {
  return (
    <Router>
      <Suspense fallback={<Loading loadingText="loading" />}>
        <Routes>
          <Route path="/" element={<StaticLayout />}>
            <Route index element={<RootRedirect />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/auth/sign_in" element={<Home />} />
            <Route path="/auth/identity_auth" element={<StaticAuth />} />
            <Route path={`/accounts/go`} element={<AccountGo />} />
            <Route path="/access/unauthorized" element={<Unauthorized />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>
          <Route path="/applications/*" element={<Applications />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/user-onboard" element={<UserOnboard />} />
          <Route path="/client-onboard" element={<PartnerSignUp />} />
          <Route path="/app/marylandSherpa" element={<MarylandSherpa />} />

          <Route
            path="app/*"
            element={
              <RequireAuth>
                <AppRoute />
              </RequireAuth>
            }
          />
        </Routes>
      </Suspense>
    </Router>
  );
}
